import {SOURCE_RASTER} from 'Map/tier/styleParts/styleResolver';
import tierProxy from 'Map/tier/tierProxy';
import mapTierFactory from 'Map/tier/mapTier';

const POSITION_MAP_TIER = 1;
const POSITION_LABELS_TIER = 4;

function createBaseMapTier(tierOptions) {
    return tierProxy(mapTierFactory(tierOptions, POSITION_MAP_TIER));
}

function createLabelMapTier(tierOptions) {
    return tierProxy(mapTierFactory(tierOptions, POSITION_LABELS_TIER, {isSymbolLayer: true}));
}

export default (options) => {
    const baseTier = createBaseMapTier(options);
    const labelsTier = createLabelMapTier(options);

    if ((options.theme && options.theme.getSource()) === SOURCE_RASTER) {
        labelsTier.setVisible(false);
    }

    return [baseTier, labelsTier];
};



// WEBPACK FOOTER //
// ./map/configurer/mapTiersFactory.js